import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import * as moment from 'moment';
import { BackOfficeInvoiceService } from 'src/app/back-office/Services/invoice.service';


@Component({
  selector: 'app-draft-invoice-logs-overview',
  templateUrl: './draft-invoice-logs-overview.component.html',
  styleUrls: ['./draft-invoice-logs-overview.component.scss']
})
export class DraftInvoiceLogsOverviewComponent implements OnInit {

  public grid: Grid;
  @ViewChild('modelTooltip', {static: true}) modelTooltip = null;
  @ViewChild('actorTemp', {static: true}) actorTemp;
  @ViewChild('draftInvoicType', {static: true}) draftInvoicType;
  @ViewChild('approveInvoiceNumber', {static: true}) approveInvoiceNumber;

  constructor(
    private readonly router: Router,
    public readonly helper: Helper,
    private readonly backOfficeInvoiceService: BackOfficeInvoiceService,
  ) {
  }

  ngOnInit() {
    const dateFormat = 'YYYY-MM-DD hh:mm';
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_number',
          prop: 'draftInvoiceId',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 200,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.approve_number',
          prop: 'approvedInvoiceNumber',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 200,
          valueTemplate: this.approveInvoiceNumber,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_date',
          prop: 'createdAt',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 190,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_action',
          prop: 'action',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 190,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_actor',
          prop: 'actor',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 250,
          valueTemplate: this.actorTemp,
        },
        <TextColumn>{
          name: 'doctrine.backoffice.invoice.draft_type',
          prop: 'type',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          maxWidth: 190,
          valueTemplate: this.draftInvoicType,
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: (row) => this.router.navigateByUrl('back-office/invoice/draft/show/' + row.draftInvoiceId + '/' + row.id ),
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.backOfficeInvoiceService,
      rememberURL: this.router.url,
      method: 'getDraftInvoiceLogs',
      defaultSort: 'createdAt',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          hasCalendar: false,
          hasDropdownListFilter: false,
          hasStatus: false,
          hasNormalSearch: true,
          order: [
            {datepickerOrder: 1}
          ],
        }
      ],
    };

  }

}
